<div class="decision-buttons">
  <div class="exchange-buttons-group">
    <div class="decision-button-card decision-button-card-active">
      <button class="decision-button decision-button-active"
              type="button"
              mat-stroked-button
              (click)="onDecisionSelected('images-sending')">
        <div class="decision-button-content">
          <mat-icon class="decision-button-icon">
            send
          </mat-icon>
          <span class="decision-button-title">
            Images Sending
          </span>
        </div>
      </button>
      <p class="decision-button-description">
        Send medical images to other facilities securely.
      </p>
    </div>

    <div class="decision-button-card decision-button-card-active">
      <button class="decision-button decision-button-active"
              type="button"
              mat-stroked-button
              (click)="onDecisionSelected('images-retrieving')">
        <div class="decision-button-content">
          <mat-icon class="decision-button-icon">
            download
          </mat-icon>
          <span class="decision-button-title">
            Images Retrieving
          </span>
        </div>
      </button>
      <p class="decision-button-description">
        Retrieve medical images from other facilities securely.
      </p>
    </div>

    <div class="decision-button-card decision-button-card-active">
      <button class="decision-button decision-button-active"
              type="button"
              mat-stroked-button
              (click)="onDecisionSelected('documents-exchange')">
        <div class="decision-button-content">
          <mat-icon class="decision-button-icon">
            description
          </mat-icon>
          <span class="decision-button-title">
            Documents Exchange
          </span>
        </div>
      </button>
      <p class="decision-button-description">
        Exchange medical documents with other facilities securely.
      </p>
    </div>
  </div>

  <div class="other-buttons-group">
    <div class="decision-button-card">
      <button class="decision-button"
              type="button"
              mat-stroked-button
              [disabled]="true">
        <div class="decision-button-content">
          <mat-icon class="decision-button-icon">
            person
          </mat-icon>
          <span class="decision-button-title">
            View Patient Profile
          </span>
        </div>
      </button>
      <p class="decision-button-description">
        Access comprehensive patient information, medical history, and detailed records in a centralized profile view.
      </p>
    </div>

    <div class="decision-button-card">
      <button class="decision-button"
              type="button"
              mat-stroked-button
              [disabled]="true">
        <div class="decision-button-content">
          <mat-icon class="decision-button-icon">
            folder
          </mat-icon>
          <span class="decision-button-title">
            Manage Patient Library
          </span>
        </div>
      </button>
      <p class="decision-button-description">
        Organize and manage patient documents, files, and medical records in a structured library format.
      </p>
    </div>
  </div>
</div>
